import { Controller } from "stimulus"
import $ from "jquery"
import "bootstrap"
import {
  parseLeadCaptureFromForm,
  openLeadCaptureModal,
  shouldSkipLeadCaptureModal
} from "./lead_capture_modal_utils"

export default class extends Controller {
  static targets = [ "selector", "submitter", "loadMore" ]

  connect() {
    let initialTimeElement = $(this.selectorTarget).find("input:checked");
    this.timeElement = initialTimeElement;
    this.daysToShow = 7; // Show first 7 days
    this.leadCaptureBypass = false

    console.log("Installation Calendar")
  }

  handleSubmit(event) {
    if (this.leadCaptureBypass) {
      this.leadCaptureBypass = false
      return
    }
    const form = this.element
    const full = parseLeadCaptureFromForm(form)
    const addressStatus = form.dataset.leadCaptureAddressStatus || ""
    const currentStep = form.dataset.leadCaptureCurrentStep || ""
    if (shouldSkipLeadCaptureModal(form, full, addressStatus, currentStep)) return

    if (!document.getElementById("leadCaptureEmailModal")) return

    event.preventDefault()
    event.stopImmediatePropagation()

    const addressId = form.dataset.leadCaptureAddressId || ""
    const opened = openLeadCaptureModal({
      modalId: "leadCaptureEmailModal",
      full,
      addressStatus,
      addressId,
      currentStep,
      form,
      onConfirm: (email) => {
        const hidden = form.querySelector('input[name="accounts_sign_up[email]"]')
        if (hidden) hidden.value = email
        // how_heard / how_heard_other are written into the form by openLeadCaptureModal
        // (via writeHowHeardToForm) before this callback fires, so submit picks them up.
        this.leadCaptureBypass = true
        form.submit()
      }
    })
    if (!opened) {
      this.leadCaptureBypass = true
      form.submit()
    }
  }

  selectInstallationTime(event) {
    let timeElement = $(event.target);
    this.timeElement = timeElement
  }

  get timeElement() {
    return this.data.get('selectedTime')
  }

  set timeElement(timeElement) {
    let selectedTime = timeElement.attr('data-time');
    this.data.set('selectedTime', selectedTime)

    $('.card.time-slot-selected').removeClass('time-slot-selected')
    timeElement.closest('.card').addClass('time-slot-selected')

    if (selectedTime) {
      $(this.submitterTarget).removeAttr("disabled")
    } else {
      $(this.submitterTarget).attr("disabled", true)
    }
  }

  selectInstallationTime(event) {
    let timeElement = $(event.currentTarget).closest("input");

    this.timeElement = timeElement;

    // Auto-scroll into view for better mobile UX
    if (window.innerWidth < 768) {
      event.currentTarget.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  get timeElement() {
    return this.data.get("selectedTime");
  }

  set timeElement(timeElement) {
    let selectedTime = timeElement.attr("data-time");
    this.data.set("selectedTime", selectedTime);

    $(".card.time-slot-selected").removeClass("time-slot-selected");
    timeElement.closest(".card").addClass("time-slot-selected");

    if (selectedTime) {
      $(this.submitterTarget).removeAttr("disabled");
    } else {
      $(this.submitterTarget).attr("disabled", true);
    }

  }

  loadMoreSlots(e) {

    e.preventDefault();

    let hiddenDays = $(".more-slots.d-none").slice(0, this.daysToShow);

    hiddenDays.removeClass("d-none");

    // If there are no more hidden slots, remove the button
    if ($(".more-slots.d-none").length === 0) {
      $(this.loadMoreTarget).remove();
    }
  }

}
